module.exports = __webpack_public_path__ + "img/24.deac25bf.png";